/* 悬浮窗*/

<template>
  <div :class="$style.floatingWindowWp" ref="suspend">
    <!-- 小球 -->
    <img
      :class="`${$style.dragBall} ${hintShow && $style.hint}`"
      :src="ball_link"
      @touchstart.stop="handleTouchStart"
      @touchend.stop="handleTouchEnd"
      @touchmove.stop="handleTouchMove"
    />
    <div
      :class="$style.marqueeBox"
      v-if="bubbleVisible && !isDrag"
      :style="{
        background: float_bubble.bg_color,
        color: float_bubble.text_color,
      }"
      ref="marqueeBox"
      @click="handleClick"
    >
      <div
        :class="$style.marqueeContent"
        :style="{
          animationDuration: float_bubble.text.length * 0.2 + 5 + 's',
        }"
      >
        {{ float_bubble.text }}
      </div>
    </div>
    <div :class="$style.hideHint" v-if="hideHintVisible">
      翻一翻可以显示/隐藏哦！
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { getStorage, setStorage } from '@/libs/utils';
import { buryReport, buryReportV2 } from '@/libs/business/account';
import moment from 'moment';

export default {
  name: '',
  data() {
    return {
      // ball_link: '//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/ball1.png?v=1',
      // 拖动相关
      oW: 0,
      oH: 0,
      oLeft: 0,
      oTop: 0,
      // ------
      isClick: true,
      active: false,
      positionLeft: true,
      positionTopLeft: false,
      positionBottomLeft: false,
      positionBottomRight: false,
      hintShow: false,
      showActFlag: false,
      resetTimer: null,
      bubbleVisible: false,
      hideHintVisible: false,
      isDrag: false,
      singleTimeout: null
    };
  },
  mounted() {
    this.initSuspend();
    this.bubbleInit();
  },
  computed: {
    ...mapState({
      remind: (state) => state.suspend.remind,
      weakRemindList: (state) => state.suspend.weakRemindList,
      activity_show_info: (state) => state.activity.activity_show_info,
      float_position: (state) => state.user.float_position,
      float_bubble_status: (state) => state.user.float_bubble_status,
      float_bubble: (state) => state.user.float_bubble,
      floatWindowVisible: state => state.user.floatWindowVisible
    }),
    ball_link() {
      if (this.activity_show_info && this.activity_show_info.float_type == 3 && !this.showActFlag) {
        return this.activity_show_info.float_background;
      }
      if (this.remind.remind == 1) {
        const { remind_icon } = this.remind;
        return remind_icon;
      }
      if (this.weakRemindList.length) {
        return '//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/ball2.png';
      }
      return '//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/ball1.png?v=1';
    },
  },
  watch: {
    floatWindowVisible(val) {
      if (!val && !this.singleTimeout && this.float_bubble) {
        setTimeout(() => {
          this.showBubble(); 
        }, this.float_bubble.interval_time * 1000)
      }
    }
  },
  methods: {
    ...mapMutations({
      changeUserState: 'user/CHANGE_STATE',
    }),
    close() {
      this.bubbleContentShow = false;
    },
    initSuspend() {
      // dom节点
      this.suspend = this.$refs.suspend;
      // 窗口宽度
      this.windowWidth = document.body.clientWidth;
      // 窗口高度
      this.windowHeight = document.body.clientHeight;
      
      const lastBallPosX = this.$getStorage('lastBallPosX');
      const lastBallPosY = this.$getStorage('lastBallPosY'); 
      if (lastBallPosX) {
        this.oLeft = lastBallPosX;
        this.suspend.style.left = lastBallPosX + 'px';
        // lastBallPosY可能为空
        if (lastBallPosY) this.suspend.style.top = lastBallPosY;
      } else if (this.float_position == 1) {
        this.oLeft = this.windowWidth;
        this.suspend.style.left = `${this.windowWidth - 45}px`;
      }
    },
    handleTouchStart(e) {
      const touches = e.touches[0];
      this.oW = touches.clientX - this.suspend.offsetLeft;
      this.oH = touches.clientY - this.suspend.offsetTop;
      this.removeResetPositionTimer();
    },
    handleTouchMove(e) {
      this.hideHintVisible = true;
      this.isClick = false;
      this.isDrag = true;

      const touches = e.touches[0];
      let oLeft = touches.clientX - this.oW;
      let oTop = touches.clientY - this.oH;
      this.positionLeft = oLeft <= this.windowWidth / 2;
      this.positionTopLeft = oTop > this.windowHeight / 2 && oLeft > this.windowWidth / 2;
      this.positionBottomLeft = oTop <= this.windowHeight / 2 && oLeft > this.windowWidth / 2;
      this.positionBottomRight = oTop <= this.windowHeight / 2 && oLeft <= this.windowWidth / 2;
      if (oLeft < 0) {
        oLeft = 0;
      } else if (oLeft > document.documentElement.clientWidth - this.suspend.offsetWidth) {
        oLeft = document.documentElement.clientWidth - this.suspend.offsetWidth;
      }
      if (oTop < 0) {
        oTop = 0 + 'px';
      } else if (oTop > document.documentElement.clientHeight - this.suspend.offsetHeight) {
        oTop = document.documentElement.clientHeight - this.suspend.offsetHeight + 'PX';
      }
      this.oLeft = oLeft;
      this.oTop = oTop;
      this.suspend.style.left = oLeft + 'PX';
      this.suspend.style.top = oTop + 'PX';
      this.setBubblePosition()
    },
    handleTouchEnd(e) {
      this.isDrag = false;
      this.hideHintVisible = false;
      this.addResetPositionTimer();
      if (this.isClick) {
        this.handleClick()
      }
      this.isClick = true;
    },
    handleClick() {
      this.showMenu();
      if (this.remind.remind == 1) {
        this.setStrongRemindCache();
      }
      if (this.bubbleVisible) {
        buryReportV2('SDK_FLOAT_BUBBLE', {
          bubble_id: this.float_bubble.id,
          bubble_name: this.float_bubble.name
        })
      }
      this.bubbleVisible = false;
      this.singleTimeout && clearTimeout(this.singleTimeout);
      this.singleTimeout = null;
    },
    // 设置强提醒点击缓存
    setStrongRemindCache() {
      const { remind_article_id } = this.remind;
      const userId = getStorage('user_id');
      const remindArticleList = getStorage('remind_article_list') || {};
      const cacheList = remindArticleList[userId] || [];
      if (!cacheList.length) {
        remindArticleList[userId] = [remind_article_id];
      } else {
        remindArticleList[userId].push(remind_article_id);
      }
      setStorage('remind_article_list', remindArticleList);
    },
    showMenu() {
      if (this.activity_show_info.float_type && !this.showActFlag) {
        this.$store.dispatch('activity/getActivityInfo');
        this.$store.commit('activity/CHANGE_STATE', {
          activity_type: 1,
          activity_show_info: {
            ...this.activity_show_info,
            visible: 1,
          },
        });
        this.showActFlag = true;
        buryReportV2('SDK_FLOAT_ACTIVITY', {
          "sum_id": this.activity_show_info.sum_id,
          "sum_name":this.activity_show_info.sum_name,
          "activity_id": this.activity_show_info.activity_id,
          "activity_name": this.activity_show_info.activity_name,
        })
        return;
      }
      buryReportV2('SDK_FLOAT_NORMAL');
      this.changeUserState({ floatWindowVisible: true });
    },
    // 重置位置回左边or右边
    addResetPositionTimer() {
      this.resetTimer = setTimeout(() => {
        if (this.oLeft <= this.windowWidth / 2) {
          this.suspend.classList.add(this.$style.linear);
          this.suspend.style.left = '-22.5px';
          this.oLeft = -22.5;
        } else {
          this.suspend.classList.add(this.$style.linear);
          this.suspend.style.left = `${this.windowWidth - 22.5}px`;
          this.oLeft = this.windowWidth - 22.5;
        }
        this.$setStorage('lastBallPosX', this.oLeft);
        this.$setStorage('lastBallPosY', this.suspend.style.top);   
      }, 3000);
    },
    removeResetPositionTimer() {
      this.suspend.classList.remove(this.$style.linear);
      this.resetTimer && clearTimeout(this.resetTimer);
      this.resetTimer = null;
    },
    // 气泡展示条件判断
    bubbleInit() {
      let count = this.$getStorage('bubble_count') || {};
      const today = moment().startOf('day').format('X');
      const latestUpdate = this.$getStorage('bubble_update_at');
      if (this.float_bubble_status == 1) {
        if (count[today] && latestUpdate === this.float_bubble.updated_at) {
          setTimeout(() => {
            this.showBubble(); 
          }, this.float_bubble.interval_time * 1000)
        } else {
          this.showBubble()
        }
      }
    },
    showBubble() {
      if (moment(this.float_bubble.show_end).diff(moment()) < 0) return;
      let count = this.$getStorage('bubble_count') || {};
      let bubble_update_at = this.$getStorage('bubble_update_at');
      const today = moment().startOf('day').format('X');
      if (count[today] && bubble_update_at === this.float_bubble.updated_at) {
        if (count[today] >= this.float_bubble.count) return;
        count[today]++;
      } else {
        count = { [today]: 1 }
      }
      this.bubbleVisible = true;
      this.$setStorage('bubble_count', count);
      this.$setStorage('bubble_update_at', this.float_bubble.updated_at);
      this.setBubblePosition()
      this.singleTimeout = setTimeout(() => {
        this.singleTimeout = null;
        this.bubbleVisible = false;
        setTimeout(() => {
          this.showBubble(); 
        }, this.float_bubble.interval_time * 1000)
      }, this.float_bubble.single_time * 1000);
    },
    // 判断气泡位置
    setBubblePosition() {
      setTimeout(() => {
        if (this.oLeft <= this.windowWidth / 2) {
          this.$refs.marqueeBox && this.$refs.marqueeBox.classList.remove(this.$style.tl);
        } else {
          this.$refs.marqueeBox && this.$refs.marqueeBox.classList.add(this.$style.tl);
        }
      })
    }
  },
};
</script>
<style lang="scss">

</style>

<style lang="scss" module>
.floatingWindowWp {
  position: absolute;
  left: 0;
  bottom: 80px;
  z-index: $suspend;
  display: inline-block;
  width: 45px;
  height: 45px;
  &.linear {
    transition: all 250ms linear;
  }
  .dragBall {
    position: absolute;
    top: 0;
    left: 0;
    width: 45px;
    height: 45px;
    z-index: 1;
    &.hint {
      &::before {
        position: absolute;
        content: ' ';
        top: 5px;
        right: 5px;
        width: 0;
        height: 0;
        border-radius: 50%;
        border: 6px solid red;
        z-index: $suspend;
      }
    }
  }
  @keyframes marqueeAnim {
    0% {
      transform: translateX(10%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  .marqueeContent {
    white-space: nowrap;
    display: inline-block;
    animation: marqueeAnim 3s linear 0s infinite;
  }
  .marqueeBox {
    position: absolute;
    top: 0;
    right: -50px;
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 20px;
    font-size: 11px;
    z-index: 2;
    text-align: left;
    overflow: hidden;
    &.tl {
      top: 0;
      left: -50px;
    }
  }
  .hideHint {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 10%;
    z-index: 5;
    margin: auto;
    display: inline-block;
    width: 170px;
    height: 30px;
    font-size: 11px;
    background: rgba(0, 0, 0, 0.4);
    line-height: 30px;
    text-align: center;
    border-radius: 30px;
    color: #FFFFFF;
  }
}
</style>
